import axios from "axios";
import imageCompression from 'browser-image-compression';
import heic2any from 'heic2any';
import { useState } from "react";
import { AiFillCloseCircle } from "react-icons/ai";
import { BsImage } from "react-icons/bs";
import { Bars, Puff } from "react-loader-spinner";
import { toast } from "react-toastify";
import { fragranceSizes } from "../../helpers/data";
import determineFileType from "../../helpers/fileType";
import { useCategoriesQuery } from "../../service/categoryApi";
import { useAddProductMutation } from "../../service/productApi";
import { uploadImage } from "../../helpers/uploadImage";
const XLSX = require("xlsx");

const AddProduct = () => {
  const { data } = useCategoriesQuery();
  const [name, setName] = useState("");
  const [brand, setBrand] = useState("");
  const [price, setPrice] = useState("");
  const [quantity, setQuantity] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("select category");
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const [shipping, setShipping] = useState("select shipping");
  const [addProduct] = useAddProductMutation();
  const [subCategory, setSubCategory] = useState("select sub-category");
  const [condition, setCondition] = useState("");
  const [selectedCat, setSelectedCat] = useState({});
  const [sizeML, setSizeML] = useState("select size");
  const shippingData = [
    {
      name: "Small box up to 2kg £3.99",
      value: 3.99,
    },
    {
      name: "Medium box up to 10kg £6.80",
      value: 6.80,
    },
    {
      name: "Large box up to 20kg £11",
      value: 11,
    },
    {
      name: "Large letter up to 1kg £2.70",
      value: 2.70,
    },
    {
      name: "Evri Parcel - £2.94",
      value: 2.94,
    },

    // {
    //   name: "UK: A (Small parcel) £3.99",
    //   value: 3.99,
    // },
    // {
    //   name: "UK: B (Medium parcel) £7.49",
    //   value: 7.49,
    // },
    // {
    //   name: "UK: C (Large parcel) £12.95",
    //   value: 12.95,
    // },
    // {
    //   name: "UK: D (Tiny parcel) £2.50",
    //   value: 2.5,
    // },
    // {
    //   name: "International: A (Small parcel) £25",
    //   value: 25,
    // },
    // {
    //   name: "International: B (Medium parcel) £35",
    //   value: 35,
    // },
    // {
    //   name: "International: C (Large parcel) £50",
    //   value: 50,
    // },
  ];

  const handleImageUpload = async (e) => {
    setLoading(true);

    if (!e.target.files || e.target.files.length === 0) {
      setLoading(false);
      return;
    }

    // Process each file
    for (let i = 0; i < e.target.files.length; i++) {
      try {
        let file = e.target.files[i];
        let fileName = file.name;

        // Cloud Run rejects requests over 32MB before they reach the server.
        const MAX_UPLOAD_BYTES = 31 * 1024 * 1024;

        // Videos can't go through image compression — upload them as-is.
        if (file.type.startsWith('video/')) {
          if (file.size > MAX_UPLOAD_BYTES) {
            toast.error(`${fileName} is too large (max 31MB). Skipping...`);
            continue;
          }
          const url = await uploadImage(file);
          setImages((prevImages) => [...prevImages, url]);
          continue;
        }

        // Check if file is HEIC
        if (file.type === 'image/heic' || file.name.toLowerCase().endsWith('.heic')) {
          try {
            // Convert HEIC to PNG
            const convertedBlob = await heic2any({
              blob: file,
              toType: 'image/png',
              quality: 0.8
            });
            
            // Create a new file from the converted blob
            file = new File([convertedBlob], fileName.replace(/\.heic$/i, '.png'), {
              type: 'image/png'
            });
            fileName = file.name;
          } catch (error) {
            console.error('Error converting HEIC:', error);
            toast.error('Failed to convert HEIC image. Skipping...');
            continue;
          }
        }

        // Compress the image (no resizing, just quality)
        try {
          file = await imageCompression(file, {
            maxSizeMB: 8,
            maxWidthOrHeight: 2560,
            initialQuality: 0.7,
            useWebWorker: true
          });
        } catch (compressionError) {
          console.error('Error compressing image:', compressionError);
          toast.error('Failed to compress image. Skipping...');
          continue;
        }

        // Upload via our API, which stores the file in Google Cloud Storage.
        const url = await uploadImage(file);
        setImages((prevImages) => [...prevImages, url]);
      } catch (error) {
        console.error('Error uploading file:', error);
        toast.error(`Failed to upload ${e.target.files[i].name}: ${error.message}`);
      }
    }

    setLoading(false);
  };
  const handleRemove = (img) => {
    const filter = images.filter((i) => i !== img);
    setImages(filter);
  };

  const handleCategory = (e) => {
    setCategory(e.target.value);
    const selected = data?.data?.find(
      (value) => value.value === e.target.value
    );
    setSelectedCat(selected);
  };

  const handleAddProduct = async () => {
    let data = {};
    if (category === "fragrances" && sizeML !== "select size") {
      data = {
        name,
        description,
        images,
        category,
        price: parseFloat(price),
        quantity: parseInt(quantity),
        brand,
        shipping,
        subCategory,
        condition,
        sizeML: sizeML,
      };
    } else {
      data = {
        name,
        description,
        images,
        category,
        price: parseFloat(price),
        quantity: parseInt(quantity),
        brand,
        shipping,
        subCategory,
        condition,
      };
    }

    if (images.length > 0) {
      if (
        name &&
        description &&
        category &&
        condition &&
        price &&
        quantity &&
        brand &&
        shipping
      ) {
        setAddLoading(true);

        addProduct(data).then((res) => {
          if (res?.data?.status) {
            toast.success(res?.data?.message);
            setName("");
            setImages([]);
            setDescription("");
            setBrand("");
            setQuantity("");
            setPrice("");
            setCondition("");
            setCategory("select category");
            setAddLoading(false);
            setCategory("select category");
            setSelectedCat({});
            setShipping("select shipping");
            setSubCategory("select sub-category");
            setSizeML("select size");
          } else {
            toast.error(res?.data?.message);
            setAddLoading(false);
          }
        });
      } else {
        toast.error("Please Fill All the required fields!");
      }
    } else {
      toast.error("Please Add at least one image!");
    }
  };

  // TODO - from custom bulk upload script - can make a bulk upload function: Requires images folder upload | xlsx file upload then bulkupload function button press
  const shippingDataBulk = [
    {
      name: "A",
      value: 4.99,
    },
    {
      name: "B",
      value: 9.99,
    },
    {
      name: "C",
      value: 14.99,
    },
    {
      name: "D",
      value: 2.5,
    },
  ];

  // async function uploadImage(filename, productName) {
  // const form = new FormData();
  // const timestamp = Date.now();
  // const s3Filename = `${productName}_${timestamp}.jpeg`;

  // form.append('image', fs.createReadStream(`./images/${filename}`), s3Filename);

  // try {
  //     const response = await axios.post('http://localhost:8080/api/v1/products/image-upload', form, {
  //         headers: form.getHeaders()
  //     });
  //     console.log(`Uploaded: ${filename} to S3 as: ${s3Filename} - URL: ${response.data.url}`);
  //     return response.data.url;
  // } catch (error) {
  //     console.error(`Failed to upload image: ${filename}`);
  //     throw error;
  // }
  // }

  async function processRow(row) {
    const images = [];
    let counter = 1;

    // if (fs.existsSync(`./images/${row.ID}.jpeg`)) {
    //     try {
    //         const primaryImageUrl = await uploadImage(`${row.ID}.jpeg`, row.name);
    //         images.push(primaryImageUrl);
    //     } catch (error) {
    //         console.error(`Error uploading primary image ${row.ID}.jpeg: ${error.message}`);
    //     }
    // }

    // while (fs.existsSync(`./images/${row.ID}.${counter}.jpeg`)) {
    //     try {
    //         const imageUrl = await uploadImage(`${row.ID}.${counter}.jpeg`, row.name);
    //         images.push(imageUrl);
    //         counter++;
    //     } catch (error) {
    //         console.error(`Error uploading image ${row.ID}.${counter}.jpeg: ${error.message}`);
    //         break;
    //     }
    // }

    const shippingObj = shippingDataBulk.find(
      (item) => item.name === row.shipping
    );
    const shippingValue = shippingObj ? shippingObj.value : null;

    const productData = {
      name: row.name,
      price: parseFloat(row.price),
      quantity: parseInt(row.quantity, 10),
      shipping: shippingValue,
      brand: row.brand,
      category: row.category,
      subCategory: row.subCategory,
      images,
      description: row.description,
      condition: row.condition,
    };
    console.log(productData);

    try {
      const res = await axios.post(
        "http://localhost:8080/api/v1/products",
        productData
      );
      console.log(res.data);
      console.log(`Successfully added product: ${row.name}`);
    } catch (error) {
      console.error(`Failed to add product: ${row.name}`);
      throw error;
    }
  }

  async function bulkUpload() {
    const workbook = XLSX.readFile("./products.xlsx");
    const sheetNameList = workbook.SheetNames;
    console.log("Sheet names:", sheetNameList);
    const rows = XLSX.utils.sheet_to_json(workbook.Sheets[sheetNameList[0]]);

    (async () => {
      for (const row of rows) {
        try {
          console.log("Processing row:", row);
          await processRow(row);
        } catch (error) {
          console.error(
            `Error processing product: ${row.name}. Error: ${error.message}`
          );
        }
      }
      console.log("XLSX file processed.");
    })();
  }

  return (
    <div className="bg-gray-700 my-[20px] rounded p-[20px]">
      <h3 className="text-start text-[20px] font-bold text-white mb-[20px]">
        Add Product
      </h3>
      <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-4 mb-3">
        <div className="mb-3 flex flex-col">
          <label className="text-white mb-[10px]">Name</label>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="bg-gray-900 outline-none font-[17px] text-white p-[10px] rounded"
          />
        </div>
        <div className="mb-3 flex flex-col">
          <label className="text-white mb-[10px]">Brand</label>
          <input
            value={brand}
            onChange={(e) => setBrand(e.target.value)}
            className="bg-gray-900 outline-none font-[17px] text-white p-[10px] rounded"
          />
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4 mb-3">
        <div className="mb-3 flex flex-col">
          <label className="text-white mb-[10px]">Price</label>
          <input
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            className="bg-gray-900 outline-none font-[17px] text-white p-[10px] rounded"
          />
        </div>
        <div className="mb-3 flex flex-col">
          <label className="text-white mb-[10px]">Quantity</label>
          <input
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            className="bg-gray-900 outline-none font-[17px] text-white p-[10px] rounded"
          />
        </div>
        <div className="mb-3 flex flex-col">
          <label className="text-white mb-[10px]">Condition</label>
          <input
            value={condition}
            onChange={(e) => setCondition(e.target.value)}
            className="bg-gray-900 outline-none font-[17px] text-white p-[10px] rounded"
          />
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-3">
        <div className="mb-3 flex flex-col">
          <label className="text-white mb-[10px]">Shipping</label>
          <select
            value={shipping}
            onChange={(e) => setShipping(e.target.value)}
            className="bg-gray-900 outline-none font-[17px] text-white p-[10px] rounded border-0 focus:outline-none focus:border-0"
          >
            <option value={"select shipping"}>Select Shipping</option>

            {shippingData?.map((d) => (
              <option key={d?.name} value={d?.value}>
                {d?.name}
              </option>
            ))}
          </select>
        </div>
        <div className="mb-3 flex flex-col">
          <label className="text-white mb-[10px]">Category</label>
          <select
            value={category}
            onChange={handleCategory}
            className="bg-gray-900 outline-none font-[17px] text-white p-[10px] rounded border-0 focus:outline-none focus:border-0"
          >
            <option value={"select category"}>Select Category</option>
            {data?.data?.map((d) => (
              <option key={d?._id} value={d?.value}>
                {d?.name}
              </option>
            ))}
          </select>
        </div>
        <div className="mb-3 flex flex-col">
          <label className="text-white mb-[10px]">Sub Category</label>
          <select
            value={subCategory}
            onChange={(e) => setSubCategory(e.target.value)}
            disabled={selectedCat?._id ? false : true}
            className="bg-gray-900 outline-none font-[17px] text-white p-[10px] rounded border-0 focus:outline-none focus:border-0"
          >
            <option value={"select sub-category"}>Select Sub-Category</option>
            {selectedCat?.subCategories?.map((d) => (
              <option key={d} value={d}>
                {d}
              </option>
            ))}
          </select>
        </div>
      </div>
      {selectedCat?.value === "fragrances" && (
        <div className="mb-3 flex flex-col">
          <label id="sizeML" className="text-white mb-[10px]">
            Fragrance Size(ML)
          </label>
          {/* <input
            value={sizeML}
            onChange={(e) => setSizeML(e.target.value)}
            className="bg-gray-900 outline-none font-[17px] text-white p-[10px] rounded"
          /> */}
          <select
            id="sizeML"
            value={sizeML}
            onChange={(e) => setSizeML(e.target.value)}
            className="bg-gray-900 outline-none font-[17px] text-white p-[10px] rounded border-0 focus:outline-none focus:border-0"
          >
            <option value={"select size"}>Select Size</option>
            {fragranceSizes?.map((d) => (
              <option key={d?.value} value={d?.value}>
                {d?.label}
              </option>
            ))}
          </select>
        </div>
      )}
      <div className="grid gap-4 mb-3">
        <div className="mb-3 flex flex-col">
          <label className="text-white mb-[10px]">Description</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="bg-gray-900 outline-none font-[17px] text-white p-[10px] rounded focus:border-0 h-[200px]"
            cols={12}
          />
        </div>
      </div>
      <div className="grid gap-4 mb-3">
        <div className="mb-3 flex flex-col">
          <label className="text-white mb-[10px]">Product Images</label>
          <div>
            <label
              className="text-[1.5rem] flex items-center gap-[.5rem] justify-center w-[100%] h-[100px] bg-gray-900 cursor-pointer text-white"
              htmlFor="banner"
            >
              {loading ? (
                <Bars
                  height="80"
                  width="80"
                  color="#fff"
                  ariaLabel="bars-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                  visible={true}
                />
              ) : (
                <>
                  <BsImage /> Upload Image
                  <input
                    onChange={handleImageUpload}
                    className="hidden"
                    type="file"
                    name="banner"
                    id="banner"
                    multiple
                    accept="image/*,.heic"
                  />
                </>
              )}
            </label>
          </div>
          {images.length > 0 && (
            <>
              <p className="text-white font-semibold text-[13px] mt-[15px]">
                Uploaded Images
              </p>
              <div className="flex flex-wrap justify-start items-center gap-[10px]">
                {images?.map((image) => (
                  <>
                    {determineFileType(image) === "video" ? (
                      <div key={image} className="relative">
                        <video
                          className="h-[200px] w-[200px] bg-slate-500"
                          key={image}
                          src={image}
                          alt="images"
                          controls
                          autoPlay={false}
                        />
                        <AiFillCloseCircle
                          style={{ color: "white" }}
                          className="h-[28px] w-[28px] absolute top-[10px] right-[10px]"
                          onClick={() => handleRemove(image)}
                        />
                      </div>
                    ) : (
                      <div key={image} className="relative">
                        <img
                          className="h-[200px] w-[200px]"
                          key={image}
                          src={image}
                          alt="images"
                        />
                        <AiFillCloseCircle
                          style={{ color: "white" }}
                          className="h-[28px] w-[28px] absolute top-[10px] right-[10px]"
                          onClick={() => handleRemove(image)}
                        />
                      </div>
                    )}
                  </>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
      <div className="grid gap-4 mb-3">
        <div className="mb-3 flex flex-col">
          <button
            onClick={handleAddProduct}
            className="bg-[#47db47] px-[20px] py-[13px] rounded text-[white] hover:bg-[#399439] active:bg-[#9b3232] flex justify-center items-center"
          >
            {addLoading ? (
              <Puff
                height="25"
                width="25"
                radius={1}
                color="#fff"
                ariaLabel="puff-loading"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
              />
            ) : (
              "Add Product"
            )}
          </button>
        </div>
      </div>
      {/* <h3 className="text-start text-[20px] font-bold text-white mb-[20px]">
        Bulk Add Product
      </h3> */}
    </div>
  );
};

export default AddProduct;
